import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Button, Row, Form, Col} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { activeUser, sendVerificationCode } from '../../actions/usersActions'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

export default function Activation() {     
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { idUser } = useParams()
    const {user, resultuser} = useSelector(state=>state.users)

    const [active_code, setActivationcode] = useState(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(false)
    const [countdown, setCountdown] = useState(0)
    
    const ActiveCodeChange = ({target})=>{
        setActivationcode(target.value)
    }

    const activate = async(e) => {
        e.preventDefault()

        dispatch(activeUser(idUser, active_code))
    }

    const sendCode = async(e) => {
        e.preventDefault()
        dispatch(sendVerificationCode(idUser))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('users.codesended')
        })

        setIsButtonDisabled(true)
        setCountdown(10)

        const interval = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown <= 1) {
                    clearInterval(interval)
                    setIsButtonDisabled(false)
                    return 0
                }
                return prevCountdown - 1
            })
        }, 1000)
    }

    useEffect(() => {
    }, [user, dispatch])

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('users.gotologin'),
                        icon: 'success',
                        text: t('users.verified')
                    }).then((resultuser) => {
                        if (resultuser.isConfirmed) {
                            navigate('/')
                        }
                    })
                    break;
                case 'wrongcode':
                    Swal.fire({
                        showConfirmButton: true,
                        confirmButtonText: t('users.tryagain'),
                        icon: 'error',
                        text: t('users.wrongcode')
                    })
                    break;
                case 'emailsended':
                    Swal.fire({
                        showConfirmButton: true,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.emailsended')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    return (
        <Container className='cuerpo'>
            <Row className="my-3">
                <Col className="d-flex justify-content-center">
                    <Form className="p-4 formulario">
                        <Row className="text-center my-3">
                            <Form.Control
                                className="login"
                                type='text'
                                name='active_code' 
                                value={active_code ||  ''}
                                placeholder={t('users.active_code')}
                                onChange={ActiveCodeChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <Button type="submit" className="btn-primary w-100 my-2" onClick={activate}>{t('users.verify')}</Button>
                        </Row>
                        <Row className="text-center my-3">
                            <Button variant="secondary" type="submit" className="w-100 my-2" onClick={sendCode} disabled={isButtonDisabled}>
                                {isButtonDisabled ? `${t('users.sendverify')} (${countdown})` : t('users.sendverify')}
                            </Button>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}
